import { Col, Form, InputNumber, notification, Row, Typography } from "antd";
import { useEffect } from "react";

import "./CashFlow.scss";
import { useBoundStore } from "store";
import { StatisticCard } from "shared/components";
import { utilityService } from "shared/services";
import { useUpdateOrganization } from "organizations/queries";

type Props = {
  name: string;
};

export const CashFlow = ({ name }: Props) => {
  const [form] = Form.useForm();
  const { mutate: saveMetadata, error } = useUpdateOrganization();
  const [api, notificationContextHolder] = notification.useNotification();
  const { currentOrganization } = useBoundStore();

  useEffect(() => {
    form.setFieldsValue({
      quickbooksCash: currentOrganization?.metadata?.quickbooksCash ?? 0,
    });
  }, [currentOrganization, form]);

  const onBlurHandler = () => {
    if (!currentOrganization) return;

    const quickbooksCash = form.getFieldValue("quickbooksCash");

    const existingMetadata = currentOrganization?.metadata ?? {};

    saveMetadata({
      ...existingMetadata,
      quickbooksCash,
    });
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Update sales target error",
        description: error?.message,
      });
    }
  }, [error, api]);

  return (
    <div className='cash-flow-container'>
      {notificationContextHolder}
      <Form
        form={form}
        name={`${name}_form`}
        data-testid={`${name}_testid`}
        requiredMark={false}
        layout='horizontal'
        initialValues={{
          quickbooksCash: currentOrganization?.metadata?.quickbooksCash ?? 0,
        }}
        onBlur={onBlurHandler}
      >
        <Row>
          <Typography.Title className='cash-flow-title' level={3}>
            Cash Flow
          </Typography.Title>
        </Row>
        <Row
          gutter={{ xs: 4, sm: 8, md: 16, lg: 20 }}
          justify={"space-between"}
          className='cash-flow-row'
        >
          <Col span={16}>
            <Typography.Text>Enter Quickbooks Cash</Typography.Text>
          </Col>
          <Col span={8}>
            <Form.Item
              name='quickbooksCash'
              colon={false}
              data-testid={`${name}_quickbooksCash_testid`}
            >
              <InputNumber size='small' variant='borderless' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row
        gutter={{ xs: 4, sm: 8, md: 16, lg: 20 }}
        justify={"space-between"}
        className='cash-flow-row'
      >
        <Col span={16}>
          <Typography.Text>Remaining Overhead</Typography.Text>
        </Col>
        <Col span={8}>
          <StatisticCard
            value={111200}
            prefix='$'
            formatter={utilityService.statisticsFormatter}
            backgroundColor='#FEC2C4'
          />
        </Col>
      </Row>
      <Row
        gutter={{ xs: 4, sm: 8, md: 16, lg: 20 }}
        justify={"space-between"}
        className='cash-flow-row'
      >
        <Col span={16}>
          <Typography.Text>Cash Flow</Typography.Text>
        </Col>
        <Col span={8}>
          <StatisticCard
            value={111200}
            prefix='$'
            formatter={utilityService.statisticsFormatter}
            backgroundColor='#E2FFF3'
          />
        </Col>
      </Row>
      <Row
        gutter={{ xs: 4, sm: 8, md: 16, lg: 20 }}
        justify={"space-between"}
        className='cash-flow-row'
      >
        <Col span={16}>
          <Typography.Text>Expected Profit</Typography.Text>
        </Col>
        <Col span={8}>
          <StatisticCard
            value={111200}
            prefix='$'
            formatter={utilityService.statisticsFormatter}
            backgroundColor='#E2FFF3'
          />
        </Col>
      </Row>
    </div>
  );
};
